import { RECEIVE_PICKUP_DATE } from './actionTypes';
import { Moment } from 'moment';

function pickUpDate(pickupDate: Moment) {
  return {
    type: RECEIVE_PICKUP_DATE,
    data: pickupDate
  }
}

function receivePickUpDate(pickupDate: Moment) {
  
  return (dispatch: any) => {
    dispatch(pickUpDate(pickupDate));
  };
}

export {
  receivePickUpDate
}